import { memo } from 'react'
import { Button } from '@campgladiator/cgui-core.atoms.button'
import { Card } from '@campgladiator/cgui-core.atoms.card'
import { Paragraph } from '@campgladiator/cgui-core.atoms.typography'
const config = process.env

const SignUpCard = memo(() => (
  <div className="signup">
    <Card raised>
      <div className="signup__content">
        <Paragraph className="signup__content-join-challenge">
          Want to join the Challenge?
        </Paragraph>
        <Button
          buttonType="link"
          secondary
          solid
          gray
          className="signup__btn-sign-up"
          target="_blank"
          href={config.REACT_APP_CHALLENGE_REGISTER_URL}
          rel="noreferrer"
        >
          Sign Up
        </Button>
      </div>
    </Card>
  </div>
))

export default SignUpCard
